import { Button, Modal } from "@shopify/polaris";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { reqPostExposureSummary } from "../../../../api";
import { useEffect, useState } from "react";
import utils from '../../../../utils/utils'
const UpgradePlanModal = ({
  isAffiliate,
  userDiscounts,
  upgradeOpen,
  setUpgradeOpen,
}) => {
  const router = useHistory();
  // 弹窗点击人数
  const handlePageStatistics = async (type) => {
    try {
      const params = { type: type };
      await reqPostExposureSummary(params);
      // 关闭弹窗
      setUpgradeOpen();
      // 跳转到pricing页面
      utils.routeListen("/admin/subscribe")
utils.routeJump1(router,"/admin/subscribe")
    } catch (error) {}
  };
  const [timers, setTimers] = useState([]); // 定时器数组

  const [contentDiscount, setContentDiscount] = useState("");
  const handleDis = (time) => {
    let content = "";
    if (upgradeOpen) {
      const timer = setInterval(() => {
        discountSubTime(time);
        content = (
          <div className="sub_paid_time_detail">
            <div className="sub_paid_time_detail_content">
              <div style={{ marginRight: "16px", width: "32px" }}>
                <img
                  style={{ width: "100%" }}
                  src="/sub/time.png"
                  alt="dropshipman"
                />
              </div>
              <div className="sub_paid_time_detail_list">
                <span className="sub_paid_time_detail_item">00</span>
                <span style={{ color: "#fff", fontSize: 18 }}>︰</span>
                <span className="sub_paid_time_detail_item">00</span>
                <span style={{ color: "#fff", fontSize: 18 }}>︰</span>
                <span className="sub_paid_time_detail_item">00</span>
              </div>
            </div>
          </div>
        );
        setContentDiscount(content);
      }, 1000);
      let timerArr = timers;
      timerArr.push(timer);
      setTimers(timerArr);
    }
  };
  // 清空所有定时器
  const clearAllTimers = () => {
    timers.forEach((timer) => {
      clearInterval(timer);
    });
    setTimers([]);
  };
  useEffect(() => {
    let isMount = false;
    if (!isMount && upgradeOpen) {
      handleDis(userDiscounts?.event_active_time);
    }
    return () => {
      isMount = true;
      clearAllTimers();
    };
    // eslint-disable-next-line
  }, [upgradeOpen, userDiscounts]);
  const discountSubTime = (time) => {
    var day;
    var hour;
    var min;
    var sec;
    var nowTime = new Date(); //现在时间
    var lastTime = parseInt((time * 1000 - nowTime) / 1000); //剩余时间=未来时间-现在时间（未来时间距离现在的秒数）
    if (lastTime >= 0) {
      day = parseInt(lastTime / 60 / 60 / 24); //换算成天数，一天有86400秒
      hour = parseInt(lastTime / 60 / 60); //余数代表剩下的小时
      min = parseInt((lastTime / 60) % 60); //代表分钟
      sec = parseInt(lastTime % 60); //代表秒数
      //给不足10的数前面添加一个0
      if (day < 10) {
        day = "0" + day;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (min < 10) {
        min = "0" + min;
      }
      if (sec < 10) {
        sec = "0" + sec;
      }
      //  console.log(hour);
    } else {
      clearAllTimers(); //清除时间
    }
    return {
      hour,
      min,
      sec,
    };
  };
  // 获取当前时间
  const getCurrentTime = () => {
    const timestamp = Date.parse(new Date()) / 1000;
    return timestamp;
  };
  
  return (
    <div className="discount_upgrade_modal">
      <Modal open={upgradeOpen} onClose={() => setUpgradeOpen()}>
        <Modal.Section>
          <div className="plan_grade_content" style={{ padding: "20px 25px" }}>
            <div className="plan_upgrade_head plan_upgrade_head_type">
              <span role="img" aria-label="emojis" style={{ fontSize: "36px" }}>
                <img src="/sub/top_emjo.png" alt="dropshipman" />
              </span>
              <p style={{ marginTop: "0" }}>
                <strong>
                  {parseFloat(
                    (1 - userDiscounts?.event_discounts) * 100
                  ).toFixed(0)}
                  %
                </strong>{" "}
                {userDiscounts?.event_type === 0 && (
                  <span>Off for New Comers</span>
                )}
                {userDiscounts?.event_type === 1 && (
                  <span>
                    OFF! Exclusive Loyalty Offer for Our{" "}
                    <span style={{ color: "#f5520c" }}>15+Days</span>{" "}
                    Supporters!
                  </span>
                )}
                {userDiscounts?.event_type === 2 && (
                  <span>
                    OFF! Exclusive Loyalty Offer for Our{" "}
                    <span style={{ color: "#f5520c" }}>91+Days</span>{" "}
                    Supporters!
                  </span>
                )}
                {userDiscounts?.event_type === 3 && (
                  <span>
                    OFF! Exclusive Loyalty Offer for Our{" "}
                    <span style={{ color: "#f5520c" }}>180+Days</span>{" "}
                    Supporters!
                  </span>
                )}
              </p>
            </div>
            {userDiscounts?.event_type === 3 && (
              <div className="plan_upgrade_conetent_detail">
                <strong>
                  ${" "}
                  {parseFloat(29.9 * userDiscounts?.event_discounts).toFixed(2)}
                </strong>{" "}
                /Month
              </div>
            )}
            {userDiscounts?.event_type === 2 && (
              <div className="plan_upgrade_conetent_detail">
                <strong>
                  ${" "}
                  {parseFloat(29.9 * userDiscounts?.event_discounts).toFixed(2)}
                </strong>{" "}
                /Month
              </div>
            )}
            {userDiscounts?.event_type === 1 && (
              <div className="plan_upgrade_conetent_detail">
                <strong>
                  ${" "}
                  {parseFloat(29.9 * userDiscounts?.event_discounts).toFixed(2)}
                </strong>{" "}
                /Month
              </div>
            )}
            {userDiscounts?.event_type === 0 && !isAffiliate && (
              <div className="plan_upgrade_conetent_detail">
                <strong>
                  ${" "}
                  {Math.ceil(29.9 * userDiscounts?.event_discounts * 100) / 100}
                </strong>{" "}
                /Month
              </div>
            )}
            {userDiscounts?.event_type === 0 && isAffiliate && (
              <div className="plan_upgrade_conetent_detail">
                <strong>
                  ${" "}
                  {Math.ceil(29.9 * userDiscounts?.event_discounts * 100) / 100}
                </strong>{" "}
                /Month
              </div>
            )}
            <div className="sub_paid_time_detail_price">$ 29.9</div>
            {userDiscounts?.event_discounts < 1 && (
              <div style={{ padding: "8px 0" }}>
                {userDiscounts?.event_discounts < 1 &&
                getCurrentTime() < userDiscounts?.event_active_time ? (
                  <div className="sub_paid_time_detail">
                    <div className="sub_paid_time_detail_content">
                      <div style={{ marginRight: "16px", width: "32px" }}>
                        <img
                          style={{ width: "100%" }}
                          src="/sub/time.png"
                          alt="dropshipman"
                        />
                      </div>
                      <div className="sub_paid_time_detail_list">
                        <span className="sub_paid_time_detail_item">
                          {
                            discountSubTime(userDiscounts?.event_active_time)
                              .hour
                          }
                        </span>
                        <span style={{ color: "#fff", fontSize: 18 }}>︰</span>
                        <span className="sub_paid_time_detail_item">
                          {
                            discountSubTime(userDiscounts?.event_active_time)
                              .min
                          }
                        </span>
                        <span style={{ color: "#fff", fontSize: 18 }}>︰</span>
                        <span className="sub_paid_time_detail_item">
                          {
                            discountSubTime(userDiscounts?.event_active_time)
                              .sec
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div style={{ height: "44px" }}>{contentDiscount}</div>
                )}
              </div>
            )}
            <div
              className="plan_upgrade_conetent_button"
              style={{ margin: "24px 0 20px" }}
            >
              <Button onClick={() => handlePageStatistics("upgrade_button")}>
                <span
                  role="img"
                  aria-label="emojis"
                  style={{ fontSize: "20px" }}
                >
                  <img
                    src="/sub/button_emjo.png"
                    alt="dropshipman"
                    style={{ verticalAlign: "bottom" }}
                  />
                </span>{" "}
                <span style={{ fontSize: "20px" }}>
                  {" "}
                  GET{" "}
                  {parseFloat(
                    (1 - userDiscounts?.event_discounts) * 100
                  ).toFixed(0)}
                  % OFF
                </span>
              </Button>
            </div>
            <div className="plan_upgrade_conetent_des">
              The offer will end in 48 hours.
            </div>
          </div>
        </Modal.Section>
      </Modal>
    </div>
  );
};

export default UpgradePlanModal;
